import { useCallback, useEffect, useState } from 'react';
import { buildService } from '../service';
import serviceMethods from '../service_methods';
const api = buildService('/claims/{id}/subsidiary_claims', {
  only: ['all', 'update']
});
const claimGroupBasedApi = buildService('/claim_groups/{id}/subsidiary_claims', {
  only: ['all']
});
const subsidiaryClaimService = {
  useFetchAllByClaimGroup: _ref => {
    let {
      setLoading,
      claimGroupId
    } = _ref;
    const [subsidiaryClaims, setSubsidiaryClaims, fetchSubsidiaryClaims] = serviceMethods.useFetch({
      callback: useCallback(async () => {
        if (!claimGroupId) {
          return [];
        }
        return (await claimGroupBasedApi.all(claimGroupId)).subsidiary_claims;
      }, [claimGroupId]),
      setLoading
    });
    return [subsidiaryClaims, setSubsidiaryClaims, fetchSubsidiaryClaims];
  },
  useFetchAll: _ref2 => {
    let {
      setLoading,
      claimId
    } = _ref2;
    const [subsidiaryClaims, setSubsidiaryClaims, fetchSubsidiaryClaims] = serviceMethods.useFetch({
      callback: useCallback(async () => {
        if (!claimId) {
          return [];
        }
        return (await api.all(claimId)).subsidiary_claims;
      }, [claimId]),
      setLoading
    });
    return [subsidiaryClaims, setSubsidiaryClaims, fetchSubsidiaryClaims];
  },
  useUpdate: function () {
    let {
      setLoading,
      setSubsidiaryClaim
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const updateSubsidiaryClaim = serviceMethods.useUpdate({
      callback: useCallback(async subsidiary_claim => {
        const updatedSubsidiaryClaim = await api.update(subsidiary_claim.claim_id, subsidiary_claim.id, {
          subsidiary_claim
        });
        setSubsidiaryClaim && setSubsidiaryClaim(updatedSubsidiaryClaim);
        return updatedSubsidiaryClaim;
      }, [setSubsidiaryClaim]),
      setLoading
    });
    return updateSubsidiaryClaim;
  }
};
const useCrud = _ref3 => {
  let {
    claimId,
    setLoading
  } = _ref3;
  const [subsidiaryClaims, setSubsidiaryClaims, fetchSubsidiaryClaims] = subsidiaryClaimService.useFetchAll({
    claimId
  });
  const updateSubsidiaryClaimState = useCallback(updatedSubsidiaryClaim => {
    setSubsidiaryClaims(subsidiaryClaims => {
      const index = subsidiaryClaims.findIndex(sc => sc.id === updatedSubsidiaryClaim.id);
      subsidiaryClaims[index] = {
        ...subsidiaryClaims[index],
        ...updatedSubsidiaryClaim
      };
      return [...subsidiaryClaims];
    });
  }, [setSubsidiaryClaims]);
  const updateSubsidiaryClaim = subsidiaryClaimService.useUpdate({
    claimId,
    setSubsidiaryClaim: updateSubsidiaryClaimState
  });
  return {
    subsidiaryClaims,
    setSubsidiaryClaims,
    fetchSubsidiaryClaims,
    updateSubsidiaryClaimState,
    updateSubsidiaryClaim
  };
};
subsidiaryClaimService.useCrud = useCrud;
export default subsidiaryClaimService;